import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function OtherStock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchId, setBranch] = useState(0);
    const [branchName, setBranchName] = useState(0);
    const [selectedBranches, setSelectedBranches] = useState([]); // Use an array for multiple selections

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    // const handleBranchSelect = (selectedOption) => {
    //     setSelectedBranch(selectedOption);
    //     const branchId = selectedOption ? selectedOption.value : '';
    //     setBranch(branchId);

    //     const branchName = selectedOption ? selectedOption.label : '';
    //     setBranchName(branchName);

    //     setDataItem([])
    // };

    const handleBranchSelect = (selectedOptions) => {
        setSelectedBranches(selectedOptions);
        const branchIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // You can now use branchIds to filter or send to the API
        setDataItem([]); // Clear the data when branches are changed
    };


    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    useEffect(() => {
        // Calculate total 
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;


        dataItem.forEach(item => {
            totalopbal += item.OpeningQty;
            totalp += item.PurchaseQty;
            totalprtn += item.PurchaseReturnQty;
            totals += item.SaleQty;
            totalsrtn += item.SaleReturnQty;
            totalstin += item.StockInQty;
            totalstout += item.StockOutQty;
            totalrpl += item.ReplaceQty;
            totalcls += item.ClosingQty;
            totalstkval += item.StockValue;
            totalsalval += item.SaleValue;
        });
        setTotalopbal(totalopbal);
        setTotalp(totalp);
        setTotalprtn(totalprtn);
        setTotals(totals);
        setTotalsrtn(totalsrtn);
        setTotalsint(totalstin);
        setTotalstout(totalstout);
        setTotalrpl(totalrpl);
        setTotalcls(totalcls);
        setTotalstkval(totalstkval);
        setTotalsalval(totalsalval);
    }, [dataItem]);

    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);

            let branchIds;

            if (selectedBranches.length === 0) {
                branchIds = branchOptions.map(branch => branch.value);
            } else {
                branchIds = selectedBranches.map(branch => branch.value);
            }

            try {
                setLoading(true);
                const branchIdsString = branchIds.join(',');
                const response = await fetchData('OtherReportApi', `/Stock/${companyId}/${branchIdsString}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const headerCaption = [`${branchName} Consolidated Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //     excelData.push(headerCaption);
    //     const headerRow = ['Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out', 'Replacement', 'Closing', 'Purchase Rate', 'MRP', 'Stock Value', 'Sale Value', 'GST%', 'HSN Code'
    //         , 'PG', 'IG', 'ISG', 'PF', 'Disc%', 'Category', 'PG Category', 'Item Group'
    //     ];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(parseFloat(rowData.Code), rowData.Name, rowData.OpeningQty, rowData.PurchaseQty, rowData.PurchaseReturnQty, rowData.SaleQty, rowData.SaleReturnQty, rowData.StockInQty, rowData.StockOutQty, rowData.ReplaceQty
    //             , rowData.ClosingQty, parseFloat(rowData.PurchaseRate.toFixed(2)), parseFloat(rowData.MRP.toFixed(2)), parseFloat(rowData.StockValue.toFixed(2)), parseFloat(rowData.SaleValue.toFixed(2)), rowData.GSTRate, rowData.HSNCode, rowData.PG, rowData.IG, rowData.ISG, rowData.PF, rowData.DiscountPercentage, rowData.CategoryName, rowData.PGCategoryName, rowData.ItemGroupName);
    //         excelData.push(dataRow);
    //     });
    //     // Add total row
    //     const totalRow = ['', 'Total', totalopbal, totalp, totalprtn, totals, totalsrtn, totalstin, totalstout, totalrpl, totalcls, , , totalstkval, totalsalval, '', '', '', ''];
    //     excelData.push(totalRow);
    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Stock');
    //     XLSX.writeFile(wb, 'Consolidated Stock.xlsx');
    // };

    // const handleExportExcel = () => {
    //     const categoryDataMap = {};

    //     // Group data by CategoryName (case-insensitive)
    //     filteredDataItem.forEach((rowData) => {
    //         const category = rowData.CategoryName.toLowerCase(); // Convert CategoryName to lowercase
    //         if (!categoryDataMap[category]) {
    //             categoryDataMap[category] = [];
    //         }
    //         categoryDataMap[category].push(rowData);
    //     });

    //     const wb = XLSX.utils.book_new();

    //     // Create a sheet with all data (without grouping)
    //     const allDataSheet = [];
    //     const allDataHeaderCaption = [`Consolidated Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //     allDataSheet.push(allDataHeaderCaption);

    //     const headerRow = ['Branch', 'Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out', 'Replacement', 'Closing', 'Purchase Rate', 'MRP', 'Stock Value', 'Sale Value', 'GST%', 'HSN Code'
    //         , 'PG', 'IG', 'ISG', 'PF', 'Disc%', 'Category', 'Group','Season Code', 'Size Code'];
    //     allDataSheet.push(headerRow);

    //     let totalopbalAll = 0;
    //     let totalpAll = 0;
    //     let totalprtnAll = 0;
    //     let totalsAll = 0;
    //     let totalsrtnAll = 0;
    //     let totalstinAll = 0;
    //     let totalstoutAll = 0;
    //     let totalrplAll = 0;
    //     let totalclsAll = 0;
    //     let totalstkvalAll = 0;
    //     let totalsalvalAll = 0;

    //     filteredDataItem.forEach((rowData) => {
    //         const dataRow = [
    //             rowData.branchName,
    //             parseFloat(rowData.Code),
    //             rowData.Name,
    //             rowData.OpeningQty,
    //             rowData.PurchaseQty,
    //             rowData.PurchaseReturnQty,
    //             rowData.SaleQty,
    //             rowData.SaleReturnQty,
    //             rowData.StockInQty,
    //             rowData.StockOutQty,
    //             rowData.ReplaceQty,
    //             rowData.ClosingQty,
    //             parseFloat(rowData.PurchaseRate.toFixed(2)),
    //             parseFloat(rowData.MRP.toFixed(2)),
    //             parseFloat(rowData.StockValue.toFixed(2)),
    //             parseFloat(rowData.SaleValue.toFixed(2)),
    //             rowData.GSTRate,
    //             rowData.HSNCode,
    //             rowData.PG,
    //             rowData.IG,
    //             rowData.ISG,
    //             rowData.PF,
    //             rowData.DiscountPercentage,
    //             rowData.CategoryName,
    //             rowData.ItemGroupName,
    //             rowData.SeasonCode,
    //             rowData.SizeCode
    //         ];
    //         allDataSheet.push(dataRow);

    //         // Update total values for the all data sheet
    //         totalopbalAll += rowData.OpeningQty;
    //         totalpAll += rowData.PurchaseQty;
    //         totalprtnAll += rowData.PurchaseReturnQty;
    //         totalsAll += rowData.SaleQty;
    //         totalsrtnAll += rowData.SaleReturnQty;
    //         totalstinAll += rowData.StockInQty;
    //         totalstoutAll += rowData.StockOutQty;
    //         totalrplAll += rowData.ReplaceQty;
    //         totalclsAll += rowData.ClosingQty;
    //         totalstkvalAll += parseFloat(rowData.StockValue.toFixed(2));
    //         totalsalvalAll += parseFloat(rowData.SaleValue.toFixed(2));
    //     });

    //     // Add total row for the all data sheet
    //     const totalRowAll = ['', '', 'Total', totalopbalAll, totalpAll, totalprtnAll, totalsAll, totalsrtnAll, totalstinAll, totalstoutAll, totalrplAll, totalclsAll, '', '', totalstkvalAll, totalsalvalAll, '', '', '', '', '', '', '', '', ''];
    //     allDataSheet.push(totalRowAll);

    //     const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);
    //     XLSX.utils.book_append_sheet(wb, allDataWs, 'All Data');

    //     // Create a sheet for each category
    //     Object.keys(categoryDataMap).forEach((category) => {
    //         const excelData = [];
    //         const headerCaption = [`Consolidated Stock For Category: ${category.charAt(0).toUpperCase() + category.slice(1)} From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //         excelData.push(headerCaption);

    //         excelData.push(headerRow);

    //         let totalopbal = 0;
    //         let totalp = 0;
    //         let totalprtn = 0;
    //         let totals = 0;
    //         let totalsrtn = 0;
    //         let totalstin = 0;
    //         let totalstout = 0;
    //         let totalrpl = 0;
    //         let totalcls = 0;
    //         let totalstkval = 0;
    //         let totalsalval = 0;

    //         categoryDataMap[category].forEach((rowData) => {
    //             const dataRow = [
    //                 rowData.branchName,
    //                 parseFloat(rowData.Code),
    //                 rowData.Name,
    //                 rowData.OpeningQty,
    //                 rowData.PurchaseQty,
    //                 rowData.PurchaseReturnQty,
    //                 rowData.SaleQty,
    //                 rowData.SaleReturnQty,
    //                 rowData.StockInQty,
    //                 rowData.StockOutQty,
    //                 rowData.ReplaceQty,
    //                 rowData.ClosingQty,
    //                 parseFloat(rowData.PurchaseRate.toFixed(2)),
    //                 parseFloat(rowData.MRP.toFixed(2)),
    //                 parseFloat(rowData.StockValue.toFixed(2)),
    //                 parseFloat(rowData.SaleValue.toFixed(2)),
    //                 rowData.GSTRate,
    //                 rowData.HSNCode,
    //                 rowData.PG,
    //                 rowData.IG,
    //                 rowData.ISG,
    //                 rowData.PF,
    //                 rowData.DiscountPercentage,
    //                 rowData.CategoryName,
    //                 rowData.ItemGroupName,
    //                 rowData.SeasonCode,
    //                 rowData.SizeCode
    //             ];
    //             excelData.push(dataRow);

    //             // Update total values
    //             totalopbal += rowData.OpeningQty;
    //             totalp += rowData.PurchaseQty;
    //             totalprtn += rowData.PurchaseReturnQty;
    //             totals += rowData.SaleQty;
    //             totalsrtn += rowData.SaleReturnQty;
    //             totalstin += rowData.StockInQty;
    //             totalstout += rowData.StockOutQty;
    //             totalrpl += rowData.ReplaceQty;
    //             totalcls += rowData.ClosingQty;
    //             totalstkval += parseFloat(rowData.StockValue.toFixed(2));
    //             totalsalval += parseFloat(rowData.SaleValue.toFixed(2));
    //         });

    //         // Add total row
    //         const totalRow = ['', '', 'Total', totalopbal, totalp, totalprtn, totals, totalsrtn, totalstin, totalstout, totalrpl, totalcls, '', '', totalstkval, totalsalval, '', '', '', '', '', '', '', '', ''];
    //         excelData.push(totalRow);

    //         const ws = XLSX.utils.aoa_to_sheet(excelData);
    //         // Capitalize the first letter of the category name for the sheet name
    //         XLSX.utils.book_append_sheet(wb, ws, category.charAt(0).toUpperCase() + category.slice(1));
    //     });

    //     // Write the workbook to a file
    //     XLSX.writeFile(wb, 'Consolidated Stock.xlsx');
    // };


    const handleExportExcel = () => {
        if (!filteredDataItem || filteredDataItem.length === 0) {
            console.warn("No data to export");
            return;
        }

        const categoryDataMap = {};
        filteredDataItem.forEach((rowData) => {
            let category = rowData.CategoryName ? rowData.CategoryName.trim() : "Unnamed Category";
            const key = category.toLowerCase();
            if (!categoryDataMap[key]) {
                categoryDataMap[key] = { name: category, rows: [] };
            }
            categoryDataMap[key].rows.push(rowData);
        });

        const workbook = new ExcelJS.Workbook();

        const headerRowValues = [
            'Branch Name','Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out',
            'Replacement', 'Closing', 'MRP', 'Sale Value', 'GST%', 'HSN Code',
            'PG', 'IG', 'ISG', 'PF', 'Disc%', 'Category', 'Group', 'Season Code', 'Size Code'
        ];

        const rightAlignColumns = [
            'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out',
            'Replacement', 'Closing', 'Purchase Rate', 'MRP', 'Stock Value', 'Sale Value', 'GST%', 'Disc%'
        ];

        const safeSheetName = (name) => name.replace(/[:\\/?*\[\]]/g, "").substring(0, 31) || "Sheet";

        const addSheetWithData = (sheetName, caption, dataRows, totalRowArray) => {
            const worksheet = workbook.addWorksheet(safeSheetName(sheetName));

            // Caption row
            worksheet.mergeCells(1, 1, 1, headerRowValues.length);
            const captionCell = worksheet.getCell(1, 1);
            captionCell.value = caption;
            captionCell.font = { size: 14, bold: true };
            captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

            // Header
            const headerRow = worksheet.addRow(headerRowValues);
            headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
            headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.views = [{ state: 'frozen', ySplit: 2 }];

            // Data rows
            dataRows.forEach(row => {
                const addedRow = worksheet.addRow(row);
                addedRow.eachCell((cell, colNumber) => {
                    if (rightAlignColumns.includes(headerRowValues[colNumber - 1])) {
                        cell.alignment = { horizontal: 'right' };
                    }
                });
            });

            // Total row
            const totalRow = worksheet.addRow(totalRowArray);
            totalRow.eachCell((cell) => {
                cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4CAF50" } };
            });

            worksheet.columns = headerRowValues.map(() => ({ width: 15 }));
        };

        // All Data
        const allDataRows = filteredDataItem.map(rowData => [
            rowData.branchName,
            parseFloat(rowData.Code),
            rowData.Name,
            rowData.OpeningQty,
            rowData.PurchaseQty,
            rowData.PurchaseReturnQty,
            rowData.SaleQty,
            rowData.SaleReturnQty,
            rowData.StockInQty,
            rowData.StockOutQty,
            rowData.ReplaceQty,
            rowData.ClosingQty,
            // parseFloat(rowData.PurchaseRate.toFixed(2)),
            parseFloat(rowData.MRP.toFixed(2)),
            // parseFloat(rowData.StockValue.toFixed(2)),
            parseFloat(rowData.SaleValue.toFixed(2)),
            rowData.GSTRate,
            rowData.HSNCode,
            rowData.PG,
            rowData.IG,
            rowData.ISG,
            rowData.PF,
            rowData.DiscountPercentage,
            rowData.CategoryName,
            rowData.ItemGroupName,
            rowData.SeasonCode,
            rowData.SizeCode
        ]);

        const totalRowAll = ['','', 'Total',
            filteredDataItem.reduce((a, b) => a + b.OpeningQty, 0),
            filteredDataItem.reduce((a, b) => a + b.PurchaseQty, 0),
            filteredDataItem.reduce((a, b) => a + b.PurchaseReturnQty, 0),
            filteredDataItem.reduce((a, b) => a + b.SaleQty, 0),
            filteredDataItem.reduce((a, b) => a + b.SaleReturnQty, 0),
            filteredDataItem.reduce((a, b) => a + b.StockInQty, 0),
            filteredDataItem.reduce((a, b) => a + b.StockOutQty, 0),
            filteredDataItem.reduce((a, b) => a + b.ReplaceQty, 0),
            filteredDataItem.reduce((a, b) => a + b.ClosingQty, 0),
            '', 
            // filteredDataItem.reduce((a, b) => a + parseFloat(b.StockValue.toFixed(2)), 0),
            filteredDataItem.reduce((a, b) => a + parseFloat(b.SaleValue.toFixed(2)), 0),
            '', '', '', '', '', '', '', '', ''
        ];

        addSheetWithData(
            "All Data",
            `Consolidated Stock From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`,
            allDataRows,
            totalRowAll
        );

        // Per Category
        Object.values(categoryDataMap).forEach(({ name, rows }) => {
            const categoryRows = rows.map(rowData => [
                rowData.branchName,
                parseFloat(rowData.Code),
                rowData.Name,
                rowData.OpeningQty,
                rowData.PurchaseQty,
                rowData.PurchaseReturnQty,
                rowData.SaleQty,
                rowData.SaleReturnQty,
                rowData.StockInQty,
                rowData.StockOutQty,
                rowData.ReplaceQty,
                rowData.ClosingQty,
                // parseFloat(rowData.PurchaseRate.toFixed(2)),
                parseFloat(rowData.MRP.toFixed(2)),
                // parseFloat(rowData.StockValue.toFixed(2)),
                parseFloat(rowData.SaleValue.toFixed(2)),
                rowData.GSTRate,
                rowData.HSNCode,
                rowData.PG,
                rowData.IG,
                rowData.ISG,
                rowData.PF,
                rowData.DiscountPercentage,
                rowData.CategoryName,
                rowData.ItemGroupName,
                rowData.SeasonCode,
                rowData.SizeCode
            ]);

            const totalRowCategory = ['','', 'Total',
                rows.reduce((a, b) => a + b.OpeningQty, 0),
                rows.reduce((a, b) => a + b.PurchaseQty, 0),
                rows.reduce((a, b) => a + b.PurchaseReturnQty, 0),
                rows.reduce((a, b) => a + b.SaleQty, 0),
                rows.reduce((a, b) => a + b.SaleReturnQty, 0),
                rows.reduce((a, b) => a + b.StockInQty, 0),
                rows.reduce((a, b) => a + b.StockOutQty, 0),
                rows.reduce((a, b) => a + b.ReplaceQty, 0),
                rows.reduce((a, b) => a + b.ClosingQty, 0),
                '', 
                // rows.reduce((a, b) => a + parseFloat(b.StockValue.toFixed(2)), 0),
                rows.reduce((a, b) => a + parseFloat(b.SaleValue.toFixed(2)), 0),
                '', '', '', '', '', '', '', '', ''
            ];

            addSheetWithData(
                name,
                `Consolidated Stock For Category: ${name} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`,
                categoryRows,
                totalRowCategory
            );
        });

        // Save file
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer]), `Consolidated_Stock_${formatDate(fromDate)}_${formatDate(toDate)}.xlsx`);
        });
    };


    const handlePrint = () => {

    };

    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];
    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Consolidated STOCK
                    </h6>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '275px' }}
                            />
                        )}
                    </div>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    {/* <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranch}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        style={{ width: '100%', marginTop: '-11px' }}
                    /> */}
                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranches}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        isMulti
                        style={{ width: '100%', marginTop: '-11px' }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Store</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Opening</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock In</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock Out</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Replacement</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Closing</TableCell>
                                {/* <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Rate</TableCell> */}
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP</TableCell>
                                {/* <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock Value</TableCell> */}
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale Value </TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST%</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>IG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>ISG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PF</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc%</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PG Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item Group</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Season Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Size Code</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '7px',
                                        height: '52px',

                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.branchName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.OpeningQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockInQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockOutQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.ReplaceQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.ClosingQty}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseRate.toFixed(2)}</TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.MRP.toFixed(2)}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockValue.toFixed(2)}</TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleValue.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.IG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ISG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PF}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.DiscountPercentage}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PGCategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ItemGroupName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.SeasonCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.SizeCode}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '52px',

                                    backgroundColor: 'teal',

                                }}
                            >
                                <TableCell colSpan={3} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalopbal}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalp}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalprtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totals}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsrtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstin}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstout}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalrpl}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalcls}</TableCell>
                                <TableCell colSpan={2} />
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstkval.toFixed(2)}</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsalval.toFixed(2)}</TableCell>
                                <TableCell colSpan={12} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}

export default OtherStock;
